import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


import { SharedModule } from '../shared/shared.module';
import { ServicesComponent } from './services.component';
import { ServicesDetailsComponent } from './services-details/services-details.component';

import { ServicesService } from './services.service';

@NgModule({
	imports: [
		BrowserModule,
		CommonModule,
		HttpModule,
		RouterModule,
		SharedModule,
	],
	declarations: [
		ServicesComponent,
		ServicesDetailsComponent
	],
	providers: [
		ServicesService
	],
})
export class ServicesModule {}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/services/services.module.ts